import React from 'react';

import WhatsappShareSvg from 'assets/images/whatsapp-share.svg';

import BaseIcon from './BaseIcon';

const WhatsappShareIcon = props => (
  <BaseIcon {...props} src={WhatsappShareSvg} />
);

export default WhatsappShareIcon;
